<template lang="pug">
md-dialog(:md-click-outside-to-close='false', :ref='dialogRef')
    md-dialog-title {{ isEdit ? 'Edit section' : 'Add new section'}}
    p.error {{ errorMessage }}
    md-dialog-content
        div.radioButtons-section(v-if="seriesInPlaylist.length > 0")
            md-checkbox.md-primary(v-model='isSeries')  Series
        md-layout.addSection()
            .md-subheading.player-size Title
            md-input-container()
                label Title
                md-input(v-model='title', :maxlength='50', :disabled='titleDisabled')
            .md-subheading.player-size() {{ !isSeries ? 'Associated tags' : 'Series'}}
            md-chips(v-if='!isSeries', v-model='associatedTags', :md-max='15', md-input-placeholder='Add a tag...')
                template(slot-scope='chip')
                    span {{ chip.value }}
            md-input-container(v-else)
                md-select(v-if="seriesInPlaylist.length > 0", v-model='selectedSeries', multiple, placeholder='Select series')
                    md-option(v-for='series in seriesInPlaylist', :key='series._id', :value='series._id') {{ series.name }}
                md-input(v-else, disabled, placeholder='No series available')
        .md-subheading.player-size Items
        div.section-items(v-if='sectionItems.length > 0')
            SlickList.section-items-list.videoContainer.md-list.custom-list.md-triple-line(lockAxis='y', v-model='sectionItems', @input='onItemsSorted', :pressDelay='100', helperClass='dragging-helper', :useWindowAsScrollContainer='true')
                SlickItem.section-item.md-list-item.sortable-item(v-for='(item, index) in sectionItems', :key='item._id', :index='index')
                    .md-list-item-container
                        md-avatar(v-if='!isSeries')
                            img(:src='getItemPoster(item)', :alt='item.name')
                        md-avatar(v-else)
                            img(:src='getItemPoster(item)', :alt='item.name')
                        div
                            span.title {{ item.name }}
                            span.detail(v-if='!isSeries && (item.duration || item.videoDuration)') {{ formatDuration(item.duration || item.videoDuration) }}
                            span.detail(v-if='!isSeries && item.credit') {{ item.credit }}
                            span.detail(v-if='isSeries') Series
                            div.tagsContainer(v-if='!isSeries')
                                span.tag.sect-series(v-if='item.serie') {{ item.serie.name ? item.serie.name : 'Series' }}
                                div.tagsContainer(v-if='item.tags && item.tags.length > 0')
                                    span.tag(v-for='tag in item.tags', :key='tag') {{ tag }}
                        div.btn-container
                            md-button.md-icon-button.md-raised#btnInfo(v-if='!isSeries', @mouseover.native='showInfo(index, true)', @mouseleave.native='showInfo(index, false)')
                                md-icon.md-icon(md-iconset="fa fa-info-circle")
                            md-button.md-icon-button.md-warn.md-list-action(@click='removeSectionItem(index)')
                                md-icon.md-icon(md-iconset="fa fa-trash-alt")
                            div.info-video(v-if='!isSeries && isShowInfo === index')
                                p.text-item(v-if='item.serie') <strong>Series: </strong> {{ item.serie.name ? item.serie.name : 'Series' }}
                                p.text-item(v-if='item.tags && item.tags.length > 0') <strong>Tags: </strong> {{ item.tags.join(', ') }}
                        md-divider
        div.no-items(v-else) No items to show
    div
        md-button.md-primary.md-raised(@click='addSection()') {{ isEdit ? 'Save' : 'Add'}}
        md-button.cancel-btn.md-raised(@click='closeDialog()') Cancel
</template>

<script>
import uuid from 'uuid';
import { SlickList, SlickItem } from 'vue-slicksort';
import videoMixin from '../../videomixins';
const mostPopularRegex = /^(most\s+popular|mostpopular)$/i;
const partnersRegex = /^partners$/i;
const reservedSectionKeySuffixes = {
    series: 'series_section',
    movies: 'movies_section'
};

export default {
    mixins: [videoMixin],
    components: {
        SlickItem,
        SlickList,
    },
    props: {
        entity: {
            type: Object,
            required: true
        },
        playlistItems: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            dialogRef: uuid.v4(),
            title: '',
            tag: '',
            associatedTags: [],
            isSeries: false,
            newSection: false,
            visible: true,
            associatedSeries: [],
            selectedSeries: [],
            seriesInPlaylist: [],
            index: 0,
            isEdit: false,
            errorMessage: '',
            titleDisabled: false,
            sectionItems: [],
            customSort: [],
            hasCustomSort: false,
            isShowInfo: null
        };
    },
    methods: {
        showInfo(index, value) {
            this.isShowInfo = value ? index : null;
        },
        removeSectionItem(index) {
            this.sectionItems.splice(index, 1);
            this.hasCustomSort = true;
            this.customSort = this.sectionItems.map(item => item._id);
        },
        getItemPoster(item) {
           
            return item ? this.getVideoPoster(item) : '/static/media-item-poster-placeholder.svg';
        },
        formatDuration(seconds) {
            if (!seconds) return '00:00:00';
            const h = Math.floor(seconds / 3600).toString().padStart(2, '0');
            const m = Math.floor((seconds % 3600) / 60).toString().padStart(2, '0');
            const s = Math.floor(seconds % 60).toString().padStart(2, '0');
            return `${h}:${m}:${s}`;
        },
        normalizeTag(tag) {
            if (tag && tag.value) return String(tag.value).trim().toLowerCase();
            if (!tag) return '';
            return String(tag).trim().toLowerCase();
        },
        getTagList() {
            return (this.associatedTags || [])
                .map(tag => this.normalizeTag(tag))
                .filter(tag => !!tag);
        },
        getSeriesId(item) {
            if (!item || !item.serie) return null;
            return typeof item.serie === 'object' ? item.serie._id : item.serie;
        },
        buildSectionKey(title) {
            const baseKey = String(title || '').toLowerCase().replace(/ /g, '_');
            return reservedSectionKeySuffixes[baseKey] || baseKey;
        },
        filterPlaylistItems() {
            const tags = this.getTagList();
            const selectedSeries = this.selectedSeries || [];
            if (!this.isSeries && tags.length === 0) return [];
            return (this.playlistItems || []).filter(item => {
                if (this.isSeries) {
                    const seriesId = this.getSeriesId(item);
                    if (!seriesId || selectedSeries.length === 0) return false;
                    return selectedSeries.includes(seriesId);
                }
                const itemTags = Array.isArray(item.tags) ? item.tags.map(tag => this.normalizeTag(tag)) : [];
                const hasTag = tags.length === 0 ? true : tags.some(tag => itemTags.includes(tag));
                return hasTag;
            });
        },
        getBaseOrder(filteredItems) {
            if (!this.isSeries) return filteredItems;
            const selectedSeries = this.selectedSeries || [];
            if (selectedSeries.length === 0) return [];
            return selectedSeries.map(seriesId => {
                const series = this.seriesInPlaylist.find(s => s._id === seriesId);
                return series || { _id: seriesId, name: 'Unknown Series' };
            });
        },
        buildSectionItems() {
            if (this.isSeries) {
                const baseOrder = this.getBaseOrder([]);
                if (!this.customSort || this.customSort.length === 0) {
                    this.sectionItems = baseOrder;
                    return;
                }

                const itemsById = new Map(baseOrder.map(item => [item._id, item]));
                const ordered = [];
                const used = new Set();
                this.customSort.forEach(id => {
                    const item = itemsById.get(id);
                    if (item) {
                        ordered.push(item);
                        used.add(id);
                    }
                });
                baseOrder.forEach(item => {
                    if (!used.has(item._id)) {
                        ordered.push(item);
                    }
                });
                this.sectionItems = ordered;
            } else {
                const filteredItems = this.filterPlaylistItems();
                if (!this.customSort || this.customSort.length === 0) {
                    this.sectionItems = filteredItems;
                    return;
                }
                const itemsById = new Map(filteredItems.map(item => [item._id, item]));
                const ordered = [];
                const used = new Set();
                this.customSort.forEach(id => {
                    const item = itemsById.get(id);
                    if (item) {
                        ordered.push(item);
                        used.add(id);
                    }
                });
                filteredItems.forEach(item => {
                    if (!used.has(item._id)) {
                        ordered.push(item);
                    }
                });
                this.sectionItems = ordered;
            }
        },
        onItemsSorted() {
            this.hasCustomSort = true;
            this.customSort = this.sectionItems.map(item => item._id);
        },
        addTag() {
            if (this.tag) {
                this.associatedTags.push(this.tag);
                this.tag = '';
            }
        },
        addSection() {
            const newSection = {
                name: this.title,
                key: this.buildSectionKey(this.title),
                type: this.isSeries ? 'playlist' : 'singlevideo',
                categoriesAssociated: [],
                tagsAssociated: this.associatedTags,
                seriesAssociated: this.isSeries ? this.selectedSeries : [],
                customSort: this.hasCustomSort ? this.sectionItems.map(item => item._id) : [],
                visible: this.visible,
            };

            if (newSection.name.trim() && newSection.tagsAssociated.length > 0 || newSection.seriesAssociated.length > 0) {
                if ((!mostPopularRegex.test(newSection.name.trim()) && !partnersRegex.test(newSection.name.trim())) || this.titleDisabled) {
                    this.isEdit
                        ? this.entity.sections.splice(this.index, 1, newSection)
                        : this.entity.sections.push(newSection);
                    this.$emit('currentsections', this.entity.sections);
                    document.body.style.overflow = '';
                    const ref = this.dialogRef;
                    this.$refs[ref].close();

                    this.errorMessage = '';
                    this.title = '';
                    this.associatedTags = [];
                    this.newSection = false;
                    this.selectedSeries = [];
                    this.sectionItems = [];
                    this.customSort = [];
                    this.hasCustomSort = false;
                } else if (partnersRegex.test(newSection.name.trim())) {
                    this.errorMessage = 'Title cannot be "Partners"';
                } else {
                    this.errorMessage = 'Title cannot be "Most Popular"';
                }
            } else {
                this.errorMessage = `Title and ${this.isSeries ? 'Series' : ' Associated tags'} are required`;
            }

        },
        closeDialog() {
            this.title = '';
            this.associatedTags = [];
            this.newSection = false;
            this.selectedSeries = [];
            this.errorMessage = '';
            this.sectionItems = [];
            this.customSort = [];
            this.hasCustomSort = false;
            document.body.style.overflow = '';
            const ref = this.dialogRef;
            this.$refs[ref].close();
            this.$emit('closed');
            this.titleDisabled = false;
        },
        openAddDialog(seriesAssocisted) {
            this.isEdit = false;
            this.errorMessage = '';
            this.title = '';
            this.associatedTags = [];
            this.isSeries = false,
                this.newSection = false;
            this.selectedSeries = [];
            this.seriesInPlaylist = seriesAssocisted;
            this.sectionItems = [];
            this.customSort = [];
            this.hasCustomSort = false;
            this.buildSectionItems();
            document.body.style.overflow = 'hidden';
            const ref = this.dialogRef;
            this.$refs[ref].open();
        },
        openEditDialog(index, section, seriesAssocisted) {
            this.isEdit = true;
            this.title = section.name;
            this.titleDisabled = mostPopularRegex.test(section.name.trim());
            this.associatedTags = section.tagsAssociated;
            this.seriesInPlaylist = seriesAssocisted;
            this.index = index;
            this.customSort = Array.isArray(section.customSort) ? section.customSort.slice() : [];
            this.hasCustomSort = this.customSort.length > 0;
            this.selectedSeries = section.seriesAssociated.map(seriesId => typeof seriesId === 'object' ? seriesId._id : seriesId);
            this.isSeries = section.type === 'playlist';
            this.$nextTick(() => {
                this.buildSectionItems();
            });
            document.body.style.overflow = 'hidden';
            const ref = this.dialogRef;
            this.$refs[ref].open();
        },
    },
    watch: {
        playlistItems: {
            handler() {
                this.buildSectionItems();
            },
            deep: true
        },
        associatedTags: {
            handler() {
                this.buildSectionItems();
            },
            deep: true
        },
        selectedSeries: {
            handler() {
                this.buildSectionItems();
            },
            deep: true
        },
        isSeries(newVal, oldVal) {
            if (!newVal && oldVal) {
                this.selectedSeries = [];
            }
            this.buildSectionItems();
        }
    }
};
</script>

<style lang="scss" scoped>
.container-images {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    max-height: 400px;
    overflow-y: auto;
}

.img-folder {
    width: 200px;
    height: 100px;
    margin: 5px;
    object-fit: contain;
}

.cancel-btn {
    background-color: #d33 !important;
    font-size: 1.1em;
    color: white !important;
}

.cancel-btn :hover {
    background-color: #d33 !important;
}

.error {
    margin-left: 25px;
    color: #ff5722;
    font-size: 16px;
}
.section-items {
    margin: 10px 0 15px;
}
.videoContainer{
    border: 1px solid hsla(0,2%,83%,.2);
    padding: 15px;
    width: 100%;
    max-height: 400px;
    overflow-y: auto;
    gap: 15px;
}
.detail {
    display: block;
}
.tagsContainer{
    display: flex;
    align-items: center;
    flex-direction: row;
    flex-wrap: wrap;
}
.tag {
    padding: 2px 5px;
    margin: 2px;
    border-radius: 6px;
    background-color: #d1dfe3ba;
    font-style: italic;
    font-size: 14px;
    &.sect-series{
        background-color: #bc1f4959;
    }
}
.info-video p{
    margin: 5px;
    margin-right: 5px;
    font-size: 14px;
}
.info-video {
    position: absolute;
    display: flex;
    align-items: center;
    right: 120px;
    bottom: 25px;
    padding: 5px 8px;
    background-color: #ffffff;
    border-radius: 5px;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
    z-index: 9999;
}
.text-item {
    color: #acd2dd;
}
#btnInfo{
    background-color: transparent !important;
    box-shadow: none !important;
}
.btn-container{
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.no-items {
    padding: 10px 0 15px;
    color: #999;
}
.dragging-helper {
    z-index: 9999 !important;
    cursor: grabbing !important;
    opacity: 0.9;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3) !important;
}
.sortable-item {
    cursor: grab;
    transition: background-color 0.2s ease;
    &:active {
        cursor: grabbing;
    }
}
</style>



// WEBPACK FOOTER //
// src/shared-components/distribution/form-components/EditOrNewSection.vue